import type { AboutInvestorRelationsContent } from '../types/AboutInvestorRelationsContent';
import { createContentHook } from './createContentHook';

export const useAboutInvestorRelationsContent = createContentHook<AboutInvestorRelationsContent>(
    '/About/InvestorRelations'
);
